import styled from "styled-components";

const ErrorContainer = styled.div`
  height: 18px;
`;

export default ErrorContainer;
